/*
    *工具 公用方法 全局方法
    *
    *
    *
*/
Array.prototype.in_array = function (element) {
　　for (var i = 0; i < this.length; i++) {
　　if (this[i] == element) {
　　  return true;
    }
  }
  return false;
}
import CryptoJS from 'crypto-js';
import { BASE_CONFIG } from '@/config/config'
import download from "@/utils/download";
import axios from 'axios'
export default {
    install(Vue, options) {
        //获取全局公共配置
        Vue.prototype.$getConfig = function(){
            return BASE_CONFIG
        }

        //返回首页
        Vue.prototype.$goHome = function (currentRout){
            let indexChildRout = ['home','productList','service','notice','partner','news','helpCenter']
            if(!indexChildRout.in_array(currentRout)){
                this.$router.push('/home')
            }
        }
        //清除全局缓存
        Vue.prototype.$removeRootScope = function (key){
            if(sessionStorage.getItem(key)){
                sessionStorage.removeItem(key);
            }
        }
        //新增缓存字段
        Vue.prototype.$setRootScope = function (key,value){
            if(sessionStorage.getItem(key)){
                sessionStorage.removeItem(key);
            }
            sessionStorage.setItem(key,value)
            //sessionStorage.setItem(key, value);
        }
        //获取缓存
        Vue.prototype.$getRootScope = function (key){
            let res = sessionStorage.getItem(key)

            return res
        }

        // 设置浏览器localStorage
        Vue.prototype.$setRootLocalStorage = function (key,value){
            if(localStorage.getItem(key)){
                localStorage.removeItem(key);
            }
            localStorage.setItem(key,value)
        }

        //获取浏览器localStorage
        Vue.prototype.$getRootLocalStorage = function (key){
            return localStorage.getItem(key)
        }

        //移除浏览器localStorage
        Vue.prototype.$removeRootLocalStorage = function (key){
            if(localStorage.getItem(key)){
                localStorage.removeItem(key);
            }
        }

        //获取浏览器传值的参数
        Vue.prototype.$getQueryString = function(name) {

            let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            let getUrl = window.location.href

            if (getUrl.indexOf("?") != -1) {
                var url = getUrl.substr(getUrl.indexOf("?"))

                let r = url.substr(1).match(reg);

                if (r != null) return decodeURIComponent(r[2]);
                return null;

            }
        }

        //cookie
        Vue.prototype.$getCookie = function(c_name){

            if (document.cookie.length > 0) {
                let c_start = document.cookie.indexOf(c_name + "=")
                if (c_start != -1) {
                    c_start = c_start + c_name.length + 1
                    let c_end = document.cookie.indexOf(";", c_start)
                    if (c_end == -1)
                        c_end = document.cookie.length
                   //return decodeURIComponent(document.cookie.substring(c_start, c_end))
                   return unescape(document.cookie.substring(c_start, c_end))
                }
            }
            return ""
        }
        Vue.prototype.$setCookie = function(name, value,expires){
            var exp = new Date();
            exp.setTime(exp.getTime() + expires * 24 * 60 * 60 * 1000); //3天过期
            //document.cookie = name + "=" + encodeURIComponent(value)
            document.cookie = name + "=" + escape(value)
                    + ";expires=" + exp.toGMTString() + ";path=/";
            return true;
        }
        const commonExp = {
            mobile:/^[1][0-9][0-9]{9}$/ ,
            email:/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-zA-Z0-9]+[-a-z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+$/,
            account:/^(?!_)(?!.*?_$)[a-zA-Z0-9_\u4e00-\u9fa5]{2,200}$/,  // 2-位数 汉字、字母、数字、下划线
            pwdStongMilddle:/^(?=.*[A-Z])(?=.*\d)[^]{6,18}$/ ,//6-18位数 数字和字母的组合
            pwdStong:/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,18}$/ ,//至少1个大写字母，1个小写字母和1个数字,
            certNo:/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            onlyNumberSpot:/^[0-9\,]+([.]{1}[0-9]{1,2})?$/, //只允许数字和小数点
        }
        // 正则匹配 表达式 统一维护
        Vue.prototype.$commonExpression = function(key){
            return commonExp[key]
        }

        // 一维数组--> 树形数组
        Vue.prototype.$arrayToTree = function(data,selfId,parentId) {
            var resVal = [];
            // 删除 所有 children,以防止多次调用
            if(data instanceof Array){
                data.forEach(function (item) {
                    delete item.children;
                    item.isShow = true;
                    item.ifFinish = false; //用于倒计时结束时删掉一个任务
                });
                var selfId = selfId;
                var parentId = parentId;
                // 将数据存储为 以 id 为 KEY 的 map 索引数据列
                var map = {};
                data.forEach(function (item) {
                    map[item[selfId]] = item;
                });

                var val = [];
                data.forEach(function (item) {
                    // 以当前遍历项，的pid,去map对象中找到索引的id
                    var parent = map[item[parentId]];
                    // 好绕啊，如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
                    if (parent) {
                        //这部分是定制化代码 不存在需求时保证不报错即可
                        parent.children || ( parent.excueCounter = 0 )
                        if(item.status && (item.status == 2 || item.status == 4)){
                            parent.excueCounter++;
                        }
                        (parent.children || ( parent.children = [] )).push(item);
                    } else {
                        //如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
                        val.push(item);
                    }
                });
                //去除root节点
                // if(val.length > 0 && val[0].children){
                //     resVal = val[0].children;
                // }
                return val;
            }
        }
        // 树形数组 --> 一维数组
        Vue.prototype.$treeToArray = function(tree, arr) {
                let res = arr
                let len = tree.length
              for (let n = 0; n < len; n++) {
                let treeItem = tree[n]
                // res.push({
                //     menuAvailable: treeItem.menuAvailable,
                //     menuDisplaySort: treeItem.menuDisplaySort,
                //     menuID: treeItem.menuID,
                //     menuLevel: treeItem.menuLevel,

                //     menuName: treeItem.menuName,
                //     menuParentID: treeItem.menuParentID,
                //     menuStatus: treeItem.menuStatus,
                //     menuType: treeItem.menuType,
                //     menuURL:treeItem.menuURL
                // })
                res.push(treeItem)
                if (treeItem.children && treeItem.children.length > 0) {
                  this.$treeToArray(treeItem.children, res)
                }
              }

              return res
        }
     

        Vue.prototype.$encryptCode = function(msg){
            return CryptoJS.AES.encrypt(msg,'crypto').toString();
        }

        Vue.prototype.$decryptCode = function(msg){
            return CryptoJS.AES.decrypt(msg,'crypto').toString(CryptoJS.enc.Utf8);
        }


        // 拷贝方法，tip: 不适用 File 类型拷贝
        Vue.prototype.$clone = function(val){
            try {
                return JSON.parse(JSON.stringify(val));
            } catch(e) {
                throw new Error('clone error')
            }
        }

        //ie浏览器
        Vue.prototype.$isIE = function(){
            let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            let isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
            let isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
            let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
            let IE = false
            if(isIE || isEdge || isIE11) {
                IE = true
            }else{
                IE = false  //不是ie浏览器
            }
            console.log('浏览器',IE)
            return IE
        }
        //不是ie11且不是谷歌的
        Vue.prototype.$isBelowIE11 = function(){
            let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            let isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
            let isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
            let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
            let IE11 = false
            if(userAgent.indexOf("Chrome") > -1 || isIE11){
                IE11 = false
            }else{
                IE11 = true  //不是ie11和谷歌浏览器
            }
            console.log('浏览器',isIE)
            return IE11
        }
        //ie浏览器
        Vue.prototype.$browser = function(){
            let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            let isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
            let isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
            let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
            var isOpera = userAgent.indexOf("Opera") > -1;
            if(isIE) {
              var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
              reIE.test(userAgent);
              var fIEVersion = parseFloat(RegExp["$1"]);
              if(fIEVersion == 7) {
                  return "IE7";
              } else if(fIEVersion == 8) {
                  return "IE8";
              } else if(fIEVersion == 9) {
                  return "IE9";
              } else if(fIEVersion == 10) {
                  return "IE10";
              } else {
                  return "IE6";//IE版本<=7
              }   
            }else if (isOpera) {//判断是否Opera浏览器
                return "Opera"
            } else if (userAgent.indexOf("Firefox") > -1) {//判断是否Firefox浏览器
                return "FF";
            } else if (userAgent.indexOf("Chrome") > -1){//判断是否Chrome浏览器
              return "Chrome";
            }else if (userAgent.indexOf("Safari") > -1) {//判断是否Safari浏览器
                return "Safari";
            } else if(isIE11) {
                return "IE11"
            }else if(isEdge) {
                return "isEdge"
            }else{
                return ""
            }
            
        }
        //获取谷歌浏览器版本号
        Vue.prototype.$getChromeVersion = function(){
            var arr = navigator.userAgent.split(' '); 
            var chromeVersion = '';
            for(var i=0;i < arr.length;i++){
                if(/chrome/i.test(arr[i]))
                chromeVersion = arr[i]
            }
            if(chromeVersion){
                return Number(chromeVersion.split('/')[1].split('.')[0]);
            } else {
                return false;
            }
            
        }
        //获取浏览器版本号
        Vue.prototype.$getChromeFullVersion = function(){
            var arr = navigator.userAgent.split(' '); 
            var chromeVersion = '';
            for(var i=0;i < arr.length;i++){
                if(/chrome/i.test(arr[i]))
                chromeVersion = arr[i]
            }
            if(chromeVersion){
                return chromeVersion
            } else {
                return "";
            }
        }

        /**
         * 下载文件 批量
         * @param {*} array
         * @param name 文件名
         * @param url 文件地址
         */
        Vue.prototype.$download = function(array = [],customFileType) {
            return new Promise((resolve,reject) => {
                const promiseList = [];
                array.forEach(file => {
                    let promise = new Promise((resolve) => {
                        const x = new XMLHttpRequest();
                        x.open("GET", file.url, true);
                        x.responseType = "blob";
                        x.onload = e => {
                            //console.log(x.response, file.name, x.response.type,customFileType)
                            download(x.response, file.name, x.response.type,customFileType,file);
                        };
                        x.send();
                        resolve();
                    })
                    promiseList.push(promise);
                });
                Promise.all(promiseList).then(() => {
                    resolve();
                })
            })
        }

        /**
         * 下载文件共同文件
         * @param name 文件名
         * @param url 文件地址
         * @param suffix 文件地址
         */
        Vue.prototype.$downloadFile = function(name,url) {
            const x = new XMLHttpRequest();
            x.open("GET", url, true);
            x.responseType = "blob";
            x.onload = e => {
              download(
                x.response,
                name,
                x.response.type
              );
            };
            x.send();
            this.$message.success("已下载");
        },
        /**
         * 下载文件共同文件
         * @param name 文件名
         * @param url 文件地址
         * @param suffix 文件地址
         */
        Vue.prototype.$downloadZip = function(name,url) {
            axios({
              url: url,
              method: 'GET',
              responseType: 'arraybuffer',
              params: {}
            }).then((res) => {
              const content = res.data
              const blob = new Blob([content], {type: "application/zip"})
              var timestamp = name+(new Date()).valueOf();
              const fileName = timestamp + '.zip'
              if ('download' in document.createElement('a')) { // 非IE下载
                const elink = document.createElement('a')
                elink.download = fileName
                elink.style.display = 'none'
                elink.href = window.URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                window.URL.revokeObjectURL(elink.href) // 释放URL 对象
                document.body.removeChild(elink)
              } else { // IE10+下载
                navigator.msSaveBlob(blob, fileName)
              }
              this.$message.success(name+"已下载");
            }).catch((err) => {
              console.log(err);
              this.$message.success(name+"下载失败");
            })
        }

        //判断系统类型
        Vue.prototype.$OSnow = function(){
            var agent = navigator.userAgent.toLowerCase();
            var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
            if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
                //alert("这是windows32位系统");
                return "win32"
            }
            if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
                //alert("这是windows64位系统");
                return "win64"
            }
            if(isMac){
                //alert("这是mac系统");
                return "mac"
            }
        }
        Vue.prototype.$isMobileDevice =function() {
                let userAgent = window.navigator.userAgent || navigator.vendor || window.opera;
                return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
           
        }

        


    }
}




// WEBPACK FOOTER //
// ./src/utils/util.js